



























import { nuclearLaunch } from '@/api/Topup/topup.api'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import Vue from 'vue'
import { VuetifyThemeItem } from 'vuetify/types/services/theme'

export default Vue.extend({
  components: {
    appConfirmDialog: ConfirmDialog,
  },
  data() {
    return {
      loading: false,
      sending: false,
      interval: null as null | NodeJS.Timeout,
      value: 0,
      dialog: false,
      colors: [
        this.$vuetify.theme.themes.light.primary,
        this.$vuetify.theme.themes.light.secondary,
        this.$vuetify.theme.themes.light.accent,
        this.$vuetify.theme.themes.light.info,
        this.$vuetify.theme.themes.light.success,
        this.$vuetify.theme.themes.light.warning,
        this.$vuetify.theme.themes.light.error,
      ],
    }
  },
  computed: {
    color(): VuetifyThemeItem {
      let value = this.value / 10
      if (value >= this.colors.length) {
        value = this.colors.length - 1
      }
      return this.colors[value]
    },
  },
  methods: {
    onMouseDown() {
      this.interval = setInterval(() => {
        this.value += 10
      }, 1000)
      this.loading = true
    },
    onMouseUp() {
      if (this.interval) {
        clearInterval(this.interval)
        this.value = 0
        this.loading = false
      }
    },
    async onDone(payload: boolean) {
      if (payload) {
        try {
          this.sending = true
          await nuclearLaunch(5000)
        } finally {
          this.sending = false
        }
      }
    },
  },
  watch: {
    value(value: number) {
      if (value >= 100) {
        this.onMouseUp()
        this.dialog = true
      }
    },
  },
})
